// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './ratio.pipe';
export * from './text-color.pipe';
// @endindex